import React, { Component } from 'react';
import './Chat.css'

import { Bubble, Send } from './Icons'
import { intlShape, FormattedMessage } from 'react-intl';

const eventLabels = {
  'abort': {
    id: 'Shared.Chat.CallCancelled',
    defaultMessage: 'Anruf abgebrochen'
  },
  'calling': {
    id: 'Shared.Chat.CallStarted',
    defaultMessage: 'Anruf gestartet'
  },
  'callend': {
    id: 'Shared.Chat.CallEnded',
    defaultMessage: 'Anruf beendet'
  },
  'accepted': {
    id: 'Shared.Chat.CallAccepted',
    defaultMessage: 'Anruf angenommen'
  },
  'denied': {
    id: 'Shared.Chat.CallDenied',
    defaultMessage: 'Anruf abgelehnt'
  },
  'online': {
    id: 'Shared.Chat.Online',
    defaultMessage: 'Online'
  },
  'offline': {
    id: 'Shared.Chat.Offline',
    defaultMessage: 'Offline'
  }
};
const otherMessages = {
  'placeHolderWriteMessage': {
    id: 'Shared.Chat.SendMessage',
    defaultMessage: 'Schreiben Sie eine Nachricht'
  },
  'you': {
    id: 'Shared.Chat.You',
    defaultMessage: 'Sie'
  }
};

class Chat extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    composeMessage: ''
  }

  componentDidUpdate(prevProps) {
    if (prevProps.messages.length !== this.props.messages.length ||
        prevProps.events.length !== this.props.events.length) {
      this.refs.messages.scrollTop = this.refs.messages.scrollHeight;
    }
  }

  onSubmitMessage(e) {
    e.preventDefault();

    if (!this.state.composeMessage.length) {
      return;
    }
    this.props.onMessage(this.state.composeMessage);
    this.setState({composeMessage: ''});

    this.refs.text.focus();
  }

  render() {
    const messageCopy = this.props.messages.slice();
    const unreadMessages = messageCopy.filter(m => !m.read);

    if (unreadMessages.length) {
      unreadMessages.forEach(m => m.read = true);
      if (this.props.onMessagesUpdate) {
        this.props.onMessagesUpdate(messageCopy);
      }
    }

    const log = this.props.events.filter(e => e.type in eventLabels).concat(this.props.messages).sort((a, b)=> a.time.getTime() - b.time.getTime());

    const logElements = log.map((m,i) => {
      const isMessage = "text" in m;
      const isLocal = (isMessage && m.from === this.props.local.id) || m.from.id === this.props.local.id;
      const author = isLocal ? this.context.intl.formatMessage(otherMessages.you) : this.props.remote.name;
      const text = isMessage ? m.text : (this.context.intl.formatMessage(eventLabels[m.type]) + ', ' + m.time.toLocaleTimeString('de-DE'));

      return <div
        key={i}
        className={"message " + (isMessage ? '' : 'event ') + (isLocal ? 'local' : 'remote')}>
          <div>
            <Bubble className="bubble" />
            <div className="author">{author}</div>
            <div className="content">{text}</div>
          </div>
        </div>;
    });

    return (
      <div className="chat" style={{display:'flex', flexDirection: 'column', height: '100%'}}>
        <div className="messages" ref="messages">
          {logElements}
        </div>
        <div className="compose">
          <form action="" method="" onSubmit={e => this.onSubmitMessage(e)}>
            <input
              autoComplete="off"
              type="text"
              ref="text"
              placeholder={this.context.intl.formatMessage(otherMessages.placeHolderWriteMessage)}
              id={this.props.local.id + this.props.remote.id + '-composefield'}
              onInput={(e) => this.setState({'composeMessage': e.target.value})}
              value={this.state.composeMessage}
            />
            <button type="submit">
              <div>
                <Send />
                <span>
                  <FormattedMessage
                    id="Shared.Chat.Send"
                    defaultMessage="Senden"
                  />
                </span>
              </div>
            </button>
          </form>
        </div>
      </div>
    )
  }
};

export default Chat;


// WEBPACK FOOTER //
// ./src/shared/Chat.js


// WEBPACK FOOTER //
// ./src/shared/Chat.js